import { createFeature, createReducer, on } from '@ngrx/store';
import { Person } from '../../data/persons/person.model';
import { Organization } from '../../data/providers/organization.model';
import { PractitionerProvider } from '../../data/providers/practitioner-provider.model';
import { logoutOAuth } from '../actions/session-auth.actions';
import {
  userOrganizationFetched,
  userOrganizationProvidersFetched,
  userPractitionerProvidersFetched,
  userPersonFetched,
} from '../actions/user-fhir.actions';

export const USER_FHIR_STATE_KEY = 'userFhir';

export type UserFhirState = {
  userPerson: Person | null;
  userOrganization: Organization | null;
  userPractitionerProviders: PractitionerProvider[] | [];
  userOrganizationProviders: Organization[] | [];
};

const initialState: UserFhirState = {
  userPerson: null,
  userOrganization: null,
  userPractitionerProviders: [],
  userOrganizationProviders: [],
};

const reducer = createReducer(
  initialState,
  on(logoutOAuth, () => initialState),
  on(userPersonFetched, (state, { userPerson }) => ({
    ...state,
    userPerson,
  })),
  on(userOrganizationFetched, (state, { userOrganization }) => ({
    ...state,
    userOrganization,
  })),
  on(
    userPractitionerProvidersFetched,
    (state, { userPractitionerProviders }) => ({
      ...state,
      userPractitionerProviders,
    }),
  ),
  on(
    userOrganizationProvidersFetched,
    (state, { userOrganizationProviders }) => ({
      ...state,
      userOrganizationProviders,
    }),
  ),
);

export const userFhirFeature = createFeature({
  name: USER_FHIR_STATE_KEY,
  reducer,
});
